export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8081.2ae18179.jpg";